import { compose } from 'redux';
import { actionCreatorFactory } from './actionCreatorFactory';
import { curry } from 'ramda';

const giveInputToReducerOnChange = curry((component, actions, input) =>
                                    actionCreatorFactory(actions[component], input));

export const onUserInput = curry((dispatch, actions, component) =>
  compose(dispatch, giveInputToReducerOnChange(component, actions)));



// WEBPACK FOOTER //
// ./src/app/stores/userInputActions.js